import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { GetClaimsParams, GetClaimsResponse } from 'api/types/claims'

class Claims {
  // get claims list
  async getClaims(
    params: GetClaimsParams,
  ): Promise<GetClaimsResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.claim.getClaimList}`

    const aditionalParams = []

    if (params.claimNo) {
      aditionalParams.push(`claimNo=${params.claimNo}`)
    }
    if (params.brokerNo) {
      aditionalParams.push(`brokerNo=${params.brokerNo}`)
    }
    if (params.policyNo) {
      aditionalParams.push(`policyNo=${params.policyNo}`)
    }
    if (params.status) {
      aditionalParams.push(`status=${params.status}`)
    }

    url += aditionalParams.length > 0 ? `?${aditionalParams.join('&')}` : ''

    return ApiProvider.getRequest(url) as Promise<
      GetClaimsResponse | (AxiosError | Error)
    >
  }
}

export const claimsService = new Claims()
